module.exports = __webpack_public_path__ + "static/assets/4e33f5533996d07dcdc2a56aaa78259d.svg";